module.exports = __webpack_public_path__ + "img/dynamics-365.adab9838.png";